<template>
  <v-card :loading="saving">
    <v-data-table :headers="headers" :loading="loading" :items="children">
      <template v-slot:item.created="{ item }">
        <div class="d-flex align-center">
          {{ item.created | moment(app_info.shortDate) }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="goToAssessment(item, 'AssessmentHome', null, true)">
          <v-icon>fal fa-angle-right</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
/* eslint-disable */
export default {
  name: "AssessmentChildren",
  data() {
    return {
      children: [],
      error: null,
      loading: false,
      resetCount: 0,
      headers: [
        {
          text: "Date",
          value: "created",
          sortable: true,
          /*  sort: (a, b) => {
              debugger;
              var aDate = new Date(a);
              var bDate = new Date(b);
              return aDate < bDate ? -1 : aDate > bDate ? 1 : 0;
            },
            */
        },
        {
          text: "Title",
          value: "assessmentTitle",
          sortable: true,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    change() {
      this.changes++;
    },
    init() {
      this.loading = true;
      this.$get(`saved/assessments/${this.assessment.id}/children`).then((response) => {
        if (response.error) {
          this.error = response.text;
        } else {
          this.children = response.data;
        }
        this.loading = false;
        this.resetCount++;
      });
    },
  },

  props: {
    assessment: {
      type: Object,
    },
    permissions: {
      type: Object,
    },
  },
};
</script>
